var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.707 8.707a1 1 0 000-1.414L2.343.929A1 1 0 00.93 2.343L6.586 8 .929 13.657a1 1 0 101.414 1.414l6.364-6.364zM7 9h1V7H7v2z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDkgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04LjcwNzExIDguNzA3MTFDOS4wOTc2MyA4LjMxNjU4IDkuMDk3NjMgNy42ODM0MiA4LjcwNzExIDcuMjkyODlMMi4zNDMxNSAwLjkyODkzMkMxLjk1MjYyIDAuNTM4NDA4IDEuMzE5NDYgMC41Mzg0MDggMC45Mjg5MzIgMC45Mjg5MzJDMC41Mzg0MDggMS4zMTk0NiAwLjUzODQwOCAxLjk1MjYyIDAuOTI4OTMyIDIuMzQzMTVMNi41ODU3OSA4TDAuOTI4OTMyIDEzLjY1NjlDMC41Mzg0MDggMTQuMDQ3NCAwLjUzODQwOCAxNC42ODA1IDAuOTI4OTMyIDE1LjA3MTFDMS4zMTk0NiAxNS40NjE2IDEuOTUyNjIgMTUuNDYxNiAyLjM0MzE1IDE1LjA3MTFMOC43MDcxMSA4LjcwNzExWk03IDlIOFY3SDdWOVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgArrow as ReactComponent };